var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Cookie.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += " <div class=\"Cookie\">\n    <span>";
output += runtime.suppressValue((lineno = 1, colno = 12, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Мы собираем cookie и другие данные в рамках"])), env.opts.autoescape);
output += " <a href=\"/static/pdf/privacy-policy.pdf\" target=\"_blank\" rel=\"nofollow noopener noreferrer\">";
output += runtime.suppressValue((lineno = 1, colno = 155, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["политики конфиденциальности"])), env.opts.autoescape);
output += ".</a></span>\n     <button class=\"Cookie-button BtnLoad u-Btn\">";
output += runtime.suppressValue((lineno = 2, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Согласиться"])), env.opts.autoescape);
output += "</button>\n </div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["Cookie.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Cookie/Cookie.jinja
// module id = 124
// module chunks = 0